import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Heading2, Heading3, Quote, Link2, Pilcrow } from "lucide-react";

export default function RichTextEditor({ value, onChange, resetKey }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  const handleInput = () => {
    if (ref.current) onChange(ref.current.innerHTML);
  };

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    if (ref.current) ref.current.focus();
    handleInput();
  };

  const addLink = () => {
    const url = window.prompt("Enter URL (include https://)");
    if (url) exec("createLink", url);
  };

  const Btn = ({ onClick, title, children }) => (
    <button
      type="button"
      title={title}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      className="p-2 rounded hover:bg-[#2a2a2e] text-gray-200 transition-colors"
    >
      {children}
    </button>
  );

  return (
    <div className="border border-[#2a2a2e] rounded-lg overflow-hidden">
      <div className="flex flex-wrap items-center gap-0.5 p-2 bg-[#1c1c1f] border-b border-[#2a2a2e]">
        <Btn title="Bold" onClick={() => exec("bold")}><Bold className="w-4 h-4" /></Btn>
        <Btn title="Italic" onClick={() => exec("italic")}><Italic className="w-4 h-4" /></Btn>
        <Btn title="Underline" onClick={() => exec("underline")}><Underline className="w-4 h-4" /></Btn>
        <span className="w-px h-5 bg-[#2a2a2e] mx-1" />
        <Btn title="Heading 2" onClick={() => exec("formatBlock", "H2")}><Heading2 className="w-4 h-4" /></Btn>
        <Btn title="Heading 3" onClick={() => exec("formatBlock", "H3")}><Heading3 className="w-4 h-4" /></Btn>
        <Btn title="Paragraph" onClick={() => exec("formatBlock", "P")}><Pilcrow className="w-4 h-4" /></Btn>
        <span className="w-px h-5 bg-[#2a2a2e] mx-1" />
        <Btn title="Bullet list" onClick={() => exec("insertUnorderedList")}><List className="w-4 h-4" /></Btn>
        <Btn title="Numbered list" onClick={() => exec("insertOrderedList")}><ListOrdered className="w-4 h-4" /></Btn>
        <Btn title="Quote" onClick={() => exec("formatBlock", "BLOCKQUOTE")}><Quote className="w-4 h-4" /></Btn>
        <Btn title="Link" onClick={addLink}><Link2 className="w-4 h-4" /></Btn>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        className="coc-editor px-4 py-3 bg-white text-gray-900"
        data-placeholder="Upload a .docx above, or start typing your grumble here..."
        onInput={handleInput}
      />
    </div>
  );
}
